export default async function sequence<T extends any = any>(promises: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]> {
    const values: Awaited<T>[] = [];
    for (let promise of [].concat(promises)) {
        values.push(await promise);
    }
    return Promise.resolve(values);
}